import type { FC, ReactNode } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';

interface HelloWorldCardProps {
  description: ReactNode;
  onClick?: () => void;
  buttonContent?: ReactNode;
}

export const HelloWorldCard: FC<HelloWorldCardProps> = ({
  description,
  onClick,
  buttonContent,
}) => {
  return (
    <div className="bg-back200 font-poppins flex flex-col items-center gap-1 rounded-[10px] border-[0.4px] border-solid border-white px-[26px] py-[10px]">
      <div className="text-text400 w-full break-words text-center text-sm font-medium leading-[18px]">
        {description}
      </div>
      {buttonContent && (
        <ClickableDiv
          className="text-silvertier text-blue700 w-fit text-center text-xs font-semibold underline"
          onClick={onClick}
        >
          {buttonContent}
        </ClickableDiv>
      )}
    </div>
  );
};
